export default __webpack_public_path__ + "6cff9e8b0a578f810ab6ffd51d5b89b5.png";